import React from 'react';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'src/shared/utils/appConstant';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';

interface IOTServicePageProps {
  title: string;
  backgroundImage: string;
  cardData: Array<{
    heading: string;
    subPoints: string[];
  }>;
}

const IOTServicePage: React.FC<IOTServicePageProps> = ({ title, backgroundImage, cardData }) => {
  return (
    <div className="page-container-services-iot">
      <div className='image-container' style={{backgroundImage: `url(${backgroundImage})`}}>
        <div className='text-container drop-in-2'>
          <h1 className='heading'>{title}</h1>
        </div>
        <p className='breadcrumb position-abs drop-in-2'>
          <Link className='breadcrumb-link' to={pageRoutes?.Home} onClick={scrollToTop}>Home </Link>
          <span className="breadcrumb-separator"> / </span>
          <Link className='breadcrumb-link' to={pageRoutes?.Services}>Services</Link>
          <span className="breadcrumb-separator"> / </span>
          <Link className='breadcrumb-link' to={pageRoutes?.IOTAutomation}>IoT Automation</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="fw-light">{title}</span>
        </p>
        <div className='red-bg-box'></div>
      </div>

      <CardsServices cardDataServices={cardData} />
      <FooterServices />
      <Footer />
    </div>
  );
};

export default IOTServicePage;